import { AxiosPromise } from 'axios'
import {
  getAllExTelcoUsersType,
  sendEmailToAllType,
  sendIndivEmailType,
  terminatedStatsType
} from 'types/api/faber/terminated.type'

import FaberApi from '.'

class TerminatedAPI {
  /** to get/post all the terminated API
   * @returns
   */

  //get list of all Ex telco Users
  static getAllExTelcoUsers(
    limit = 10,
    offset = 10,
    faberToken: string
    // searchCriteria: string,
    // searchValue: string
  ): AxiosPromise<getAllExTelcoUsersType> {
    const userID = ''
    const email = ''
    const oldNumber = ''
    const newNumber = ''
    const sin = ''

    // switch (searchCriteria) {
    //   case 'user Id':
    //     userID = searchValue.length > 0 ? `&userID=${searchValue}` : ''
    //     break
    //   case 'User Email':
    //     email = searchValue.length > 0 ? `&email=${searchValue}` : ''
    //     break
    //   case 'old Number':
    //     oldNumber = searchValue.length > 0 ? `&oldNumber=${searchValue}` : ''
    //     break
    //   case 'new Number':
    //     newNumber = searchValue.length > 0 ? `&newNumber=${searchValue}` : ''
    //     break
    //   case 'SIN':
    //     sin = searchValue.length > 0 ? `&sin=${searchValue}` : ''
    //     break
    // }

    return FaberApi.httpGet(
      `/telco/user?offset=${offset}&limit=${limit}${userID}${email}${oldNumber}${newNumber}${sin}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getTerminatedUserStats(
    faberToken: string
  ): AxiosPromise<terminatedStatsType> {
    return FaberApi.httpGet(`/telco/user/summary`, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static sendEmailToAllUsers(
    faberToken: string
  ): AxiosPromise<sendEmailToAllType> {
    return FaberApi.httpPost(`/telco/user/sendemail`, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  static sendIndivEmail(body: {
    userId: string
    faberToken: string
  }): AxiosPromise<sendIndivEmailType> {
    return FaberApi.httpPost(
      `/telco/selecteduser/sendemail`,
      { Authorization: `Bearer ${body.faberToken}` },
      body
    )
  }
}

export default TerminatedAPI
